import { Directive, TemplateRef } from '@angular/core';

@Directive({
  selector: '[buttonToggleIcon]',
  standalone: true
})
export class ButtonToggleIconDirective {
  constructor(public tpl: TemplateRef<any>) {}
}
